/**
 * Shared copy for session carry forward — whether absent students are charged.
 */
import i18n from '../i18n';

const CARRY_FORWARD_MODE_VALUES = ['ALLOWED', 'NOT_ALLOWED', 'ENROLLMENT_LEVEL'];

export function getCarryForwardColumnHelp() {
    return i18n.t('carryForward.columnHelp');
}

/** Options resolved at call time for the active locale. */
export function getCarryForwardModeOptions() {
    return CARRY_FORWARD_MODE_VALUES.map((value) => ({
        value,
        label: i18n.t(`carryForward.modes.${value}.label`),
        desc: i18n.t(`carryForward.modes.${value}.desc`),
    }));
}

export function batchPolicyTitle(mode) {
    const key = mode && i18n.exists(`carryForward.batchPolicyTitle.${mode}`)
        ? mode
        : 'default';
    return i18n.t(`carryForward.batchPolicyTitle.${key}`);
}

export function studentOverrideTitle(enabled) {
    return i18n.t(`carryForward.studentOverrideTitle.${enabled ? 'enabled' : 'disabled'}`);
}

export function batchPolicySummary(mode) {
    if (!mode || !i18n.exists(`carryForward.batchPolicySummary.${mode}`)) return '';
    return i18n.t(`carryForward.batchPolicySummary.${mode}`);
}

export function batchPolicyLabel(mode) {
    const key = mode && i18n.exists(`carryForward.batchPolicyLabel.${mode}`)
        ? mode
        : 'unknown';
    return i18n.t(`carryForward.batchPolicyLabel.${key}`);
}

export function studentOverrideShort(enabled) {
    return i18n.t(`carryForward.studentOverrideShort.${enabled ? 'enabled' : 'disabled'}`);
}

export function attendanceCellLabel({ batchMode, overrideCarryForward }) {
    const modeLabel = (mode) => {
        if (!mode) return i18n.t('carryForward.attendanceCell.unknown');
        if (i18n.exists(`carryForward.modes.${mode}.label`)) {
            return i18n.t(`carryForward.modes.${mode}.label`);
        }
        return mode;
    };
    if (batchMode === 'ALLOWED' || batchMode === 'NOT_ALLOWED') {
        return i18n.t('carryForward.attendanceCell.followsBatch', { mode: modeLabel(batchMode) });
    }
    if (overrideCarryForward === null || overrideCarryForward === undefined) {
        return i18n.t('carryForward.attendanceCell.followsBatch', {
            mode: modeLabel(batchMode),
        });
    }
    return overrideCarryForward
        ? i18n.t('carryForward.attendanceCell.enabled')
        : i18n.t('carryForward.attendanceCell.disabled');
}

export function attendanceCellTooltip({ batchMode, overrideCarryForward }) {
    if (batchMode === 'ALLOWED' || batchMode === 'NOT_ALLOWED') {
        return batchPolicyTitle(batchMode);
    }
    if (overrideCarryForward === null || overrideCarryForward === undefined) {
        return batchPolicyTitle(batchMode || 'ENROLLMENT_LEVEL');
    }
    return studentOverrideTitle(overrideCarryForward);
}
